import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import { capitalize } from 'lodash';
import { BulbOutlined } from '@ant-design/icons';

import { articleStatusType } from 'common/constants/content';

import BackBtn from '~client/components/back-btn';
import { getSafeHtml } from 'common/helpers/safeHtml';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: 80,
    padding: '0 24px',
    backdropColor: theme.colors.gray1,
    boxShadow: 'inset 0px 1px 0px rgba(0, 0, 0, 0.09)',
  },
  exitBtn: {
    marginBottom: 0,
  },
  rightArea: {
    display: 'flex',
    alignItems: 'center',
  },
  notice: {
    color: theme.colors.captionColor,
  },
  noticeText: {
    ...theme.typography.body2,
    paddingLeft: 6,
  },
  noticeTextStrong: {
    fontWeight: 600,
  },
}));

const Footer = ({ status, loading, disabled, handleSaveArticle }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();

  const handleExitClick = () => {
    history.goBack();
  };

  const handleSaveClick = () => {
    handleSaveArticle(articleStatusType.DRAFT);
  };

  const handlePublishClick = () => {
    handleSaveArticle(articleStatusType.PUBLISHED);
  };

  return (
    <div className={classes.container}>
      <BackBtn text={t('global.btn.exit')} className={classes.exitBtn} onClick={handleExitClick} />

      <div className={classes.rightArea}>
        <div className={classes.notice}>
          <BulbOutlined />
          <span className={classes.noticeText}>
            {getSafeHtml(
              t(`content.article.copywriting.${status?.toLowerCase()}`, {
                status: `<span className={classes.noticeTextStrong}>${capitalize(status)}</span>`,
              }),
            )}
          </span>
        </div>

        <Button
          type="default"
          size="large"
          style={{ marginLeft: 24 }}
          loading={loading}
          disabled={disabled}
          onClick={handleSaveClick}
        >
          {t('content.article.btn.draft')}
        </Button>
        <Button
          type="primary"
          size="large"
          style={{ marginLeft: 16, fontWeight: 600 }}
          loading={loading}
          disabled={disabled}
          onClick={handlePublishClick}
        >
          {t('content.article.btn.publish')}
        </Button>
      </div>
    </div>
  );
};

export default Footer;
